// extracted by mini-css-extract-plugin
module.exports = {"obituaryVideo":"VideoPlayer_obituaryVideo__9i7gl"};